<template>
  <div v-if="!isMobileScreen" class="signin">
    <div class="signin__letfside bg-primary-opacity">
      <onboarding />
    </div>
    <div class="signin__rightside">
      <sign-in-form />
      <helpdesk />
    </div>
  </div>
  <div v-else class="signin">
    <div class="signin__mobile--wrapper">
      <sign-in-form />
      <helpdesk />
    </div>
  </div>
</template>

<script>
import Onboarding from "@/components/onboarding/Onboarding.vue";
import SignInForm from "@/components/form/SignInForm.vue";
import Helpdesk from "@/components/helpdesk/Helpdesk.vue";  

import { get } from "lodash";

export default {
  components: {
    Onboarding,
    SignInForm,
    Helpdesk,
  },
  computed: {
    isMobileScreen() {
      return window.innerWidth < 768;
    },
  },
  methods: {
    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/login`)
        : this.$ga.page(`${company_label}/login`);
    },
  },
  data: () => ({
    isLoading: true,
  }),
  created() {
    const label = get(this.$router, 'history.current.params.company_label', null);
    if (label === 'anonima') return;
    this.googleAnalytics();
  },
};
</script>

<style lang="scss" scoped>
.signin {
  width: 100%;
  height: 100vh;
  display: flex;

  &__letfside {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    height: 100%;
  }

  &__rightside {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    max-height: 100vh;
    min-width: 440px;
    padding: 0 40px;
  }

  &__mobile--wrapper {
    margin: 0 auto;
    align-self: center;
    justify-self: center;
  }
}
</style>
